import { type IWidgetDirectiveType } from '@framework/engine/schema/directives/IWidgetDirectiveType.ts';
import { isInputWidget } from '@framework/engine/schema/widgets/repository/inputs/isInputWidget.ts';
import { WidgetType } from '@framework/engine/schema/widgets/Widget.ts';
import { FormBuilderMetaFlags } from '@framework/engine/validator/form-builder/flags/FormBuilderMetaFlags.ts';
import { MapWidgetType } from '../../widgets/map/MapWidget.type.tsx';
import {
  type ISubjectDataDirective,
  SubjectDataDirectiveSchema,
} from './ISubjectDataDirective.ts';
import { SubjectDataDirectiveConfigComponent } from './SubjectDataDirectiveConfigComponent.tsx';

export const DIRECTIVE_SUBJECT_DATA_META_KEY = 'directiveSubjectData';
export const DIRECTIVE_SUBJECT_DATA_TYPE_META_KEY = 'directiveSubjectDataType';

export const SubjectDataDirectiveType: IWidgetDirectiveType<ISubjectDataDirective> =
  {
    /**
     * Update FWP-1465: convertiamo tutti i campi in "subject data" ma manteniamo name e key
     * per compatibilità con il vecchio sistema.
     */
    name: 'applicantData',
    key: 'applicantData',
    allowsWidget: (widget, widgetType) =>
      isInputWidget(widget) &&
      widget.type !== WidgetType.Repeatable &&
      widget.type !== MapWidgetType.type,
    configComponent: SubjectDataDirectiveConfigComponent,
    configSchema: SubjectDataDirectiveSchema,
    formSchemaModifier: ({ directiveConfig, schema, flags }) => {
      if (!directiveConfig.code) {
        console.warn(`[SubjectDataDirectiveType] Missing name in config`);
        return schema;
      }

      if (flags[FormBuilderMetaFlags.SkipValidationRules]) {
        // Se le regole di validazione non sono attive, vuol dire che
        // non è il campo "principale" del Widget, quindi non dobbiamo
        // esportarlo.
        return schema;
      }

      // Salviamo il valore del campo da esportare nei meta, così da accedervi
      // in fase di estrazione
      return schema.meta?.({
        [DIRECTIVE_SUBJECT_DATA_META_KEY]: directiveConfig.code,
        [DIRECTIVE_SUBJECT_DATA_TYPE_META_KEY]: directiveConfig.type,
      });
    },
    supportedSectionTypes: ['BACKOFFICE', 'FRONTOFFICE'],
  };
